export const pauseAllAudioAndVideo = (ref = null) => {
  if (!document) {
    return;
  }

  document?.querySelectorAll('audio')?.forEach((audio) => {
    // pause all other audio but itself
    if (ref?.current?.id !== audio?.id) {
      audio.pause();
    }
  });
  document?.querySelectorAll('video')?.forEach((video) => {
    // pause all other audio but itself
    if (ref?.current?.id !== video?.id) {
      video.pause();
    }
  });
};
